import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DatePickerField from './DatePickerField';

const WarrantySelect = ({ value, onChange, inputClass, warrantyPurchaseDate, onPurchaseDateChange }) => {
  const { t } = useTranslation();
  const [showDatePicker, setShowDatePicker] = useState(false);
  
  const handleWarrantyChange = (e) => {
    const newValue = e.target.value;
    onChange(newValue);
    if (newValue === 'yes') {
      setShowDatePicker(true);
    } else {
      setShowDatePicker(false);
      if (onPurchaseDateChange) {
        onPurchaseDateChange('');
      }
    }
  };

  // Format date for input (YYYY-MM-DD) - keep same format as before
  const formatDateForInput = (date) => {
    if (!date) return '';
    if (typeof date === 'string') {
      // If already in YYYY-MM-DD format, return as is
      if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
        return date;
      }
      return date.split('T')[0];
    }
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleDateChange = (dateString) => {
    if (onPurchaseDateChange) {
      // dateString is already in YYYY-MM-DD format from DatePickerField
      onPurchaseDateChange(dateString);
    }
  };

  return (
    <div className="min-h-[40px]">
      <label className="block text-sm font-medium text-gray-200 mb-1 mt-2">
        {t('jobs.warranty')}
      </label>
      <select
        name="warranty"
        value={value || 'no'}
        onChange={handleWarrantyChange}
        className={inputClass}
      >
        <option value="no">{t('jobs.noWarranty')}</option>
        <option value="yes">{t('jobs.underWarranty')}</option>
      </select>
      
      {(value === 'yes' || showDatePicker) && (
        <div className="mt-2">
          <label className="block text-sm font-medium text-gray-200 mb-1 mt-1">
            {t('jobs.warrantyPurchaseDate', 'Datum kupovine aparata')}
          </label>
          <DatePickerField
            value={formatDateForInput(warrantyPurchaseDate)}
            onChange={handleDateChange}
            inputClass={inputClass}
            placeholder="dd.mm.yyyy"
            maxDate={new Date()} // Can't be in the future
          />
        </div>
      )}
    </div>
  );
};

export default WarrantySelect;


